import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { useFieldArray } from "react-hook-form";
import Dropdown2 from "../dropdown2/Dropdown2";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "../constants/constants.css";
import AdPositionDetails2 from "../adPositionDetails2/AdPositionDetails2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./AdPositionListItem2.css";

const AdPositionListItem2 = ({
  control,
  register,
  index,
  indexAdPosition,
  setManageCreatives,
  manageCreatives,
  creativeNumber,
  positionNumber,
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `creatives[${index}].adPositions[${indexAdPosition}].positionsList`,
  });

  const [positionListNumber, setPositionListNumber] = useState(0);
  const [overlayActive, setOverlayActive] = useState(false);
  const [sidebarAdPositionDetailsForm, setSidebarAdPositionDetailsForm] =
    useState(false);

  const elementRoleOptions = [
    {label: 'Fixed Position', value: 'fixedPosition'},
    {label: 'Layer Position', value: 'layerPosition'},
    {label: 'Vast or Vpaid', value: 'mediaFile'}
  ];

  // Here we add a html file inside the manageCreatives object when detecting the right creative and adPosition.
  function addHTMLFileNumber() {
    let listItemToBeAdded;
    let newPosition;

    if (
      manageCreatives[creativeNumber].adPositions[positionNumber].positionsList
    ) {
      let listItemToBeAdded;
      listItemToBeAdded =
        manageCreatives[creativeNumber].adPositions[positionNumber]
          .positionsList.length;
      newPosition = { title: listItemToBeAdded + 1 };
    }

    newPosition = { title: listItemToBeAdded + 1 };

    let newItem = [];

    manageCreatives.forEach((item, index) => {
      if (index !== creativeNumber) {
        newItem.push(item);
      } else {
        let newCreativeObject = {
          creative: item.creative,
          adPositions: [],
        };
        item.adPositions.forEach((position, index) => {
          if (index !== positionNumber) {
            newCreativeObject.adPositions.push(position);
          } else {
            let newPositionObject = {
              position: position.position,
              positionsList: [],
            };
            if (position.positionsList) {
              position.positionsList.forEach((listItem) => {
                newPositionObject.positionsList.push(listItem);
              });
            }
            newPositionObject.positionsList.push(newPosition);
            newCreativeObject.adPositions.push(newPositionObject);
          }
        });
        newItem.push(newCreativeObject);
      }
    });

    setManageCreatives(newItem);
  }

  // Here we update the number of HTML file buttons after deleting one position.
  function updateDisplayHTMLButtonsAfterDelete() {
    manageCreatives[creativeNumber].adPositions[
      positionNumber
    ].positionsList.pop();
  }

  // This is the gray overlay behind the sidebars and will deactivate the sidebars on click
  const resetOverlay = () => {
    setOverlayActive(false);
    setSidebarAdPositionDetailsForm(false);
  };

  // This button is used to switch between HTML file sidebars to be shown on the screen.
  function displayHTMLFile(e, number) {
    e.preventDefault();
    setPositionListNumber(number);
    showSidebarHtmlFileDetails();
  }

  // This will show or hide the html file info sidebar
  const showSidebarHtmlFileDetails = () => {
    setSidebarAdPositionDetailsForm(!sidebarAdPositionDetailsForm);
    setOverlayActive(!overlayActive);
  };

  return (
    <div className="form-wrapper">
      <div className="position-container-form">
        {fields.map((item, indexPosition) => {
          return (
            <div key={item.id}>
              <div className="input-container">
                <div className="inner-input-container">
                  <div className="html-file-wrapper">
                    <section className="ad-position-type-wrapper">
                      <div>
                        <Controller
                          control={control}
                          name="elementRole"
                          render={({ field: { onChange, value } }) => (
                            <Dropdown2
                              label="Element Role * "
                              options={elementRoleOptions}
                              name="elementRole"
                              value={value}
                              onChange={onChange}
                              fieldRef={register(
                                `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].type`,
                                { required: true }
                              )}
                            />
                          )}
                        />
                      </div>
                    </section>
                    <InputFieldFormArray
                      label={`Title HTML file ${indexPosition + 1}`}
                      placeholder="Rectangle"
                      fieldRef={register(
                        `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].title`,
                        {
                          required: false,
                        }
                      )}
                      name={`creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].title`}
                      key={item.id}
                    />
                    <InputFieldFormArray
                      label="HTML name "
                      placeholder="300x250.html"
                      fieldRef={register(
                        `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].htmlName`,
                        {
                          required: false,
                        }
                      )}
                      name={`creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].htmlName`}
                      key={item.id + 1}
                    />

                    <button
                      className="display-html-button"
                      key={indexPosition}
                      onClick={(e) => {
                        displayHTMLFile(e, indexPosition);
                      }}
                    >
                      {`HTML file specs`}
                    </button>

                    <button
                      className="position-list-item-button delete-button small"
                      type="button"
                      onClick={() => {
                        remove(indexPosition);
                        updateDisplayHTMLButtonsAfterDelete();
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                {indexPosition === positionListNumber && (
                  <div
                    className={
                      sidebarAdPositionDetailsForm
                        ? "position-details-slider__active"
                        : "position-details-slider"
                    }
                  >
                    <div className="slider-container">
                      <div className="container-title-slider">
                        <p className="title-slider">SPECIFICATIONS</p>

                        <FontAwesomeIcon
                          className="close-icon"
                          icon={faXmark}
                          onClick={showSidebarHtmlFileDetails}
                        />
                      </div>

                      <AdPositionDetails2
                        {...{
                          control,
                          register,
                          index,
                          indexAdPosition,
                          indexPosition,
                          positionListNumber,
                          showSidebarHtmlFileDetails,
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="append-button"
        type="button"
        onClick={() => {
          append({
            type: "fixedPosition",
            title: "",
            htmlName: "",
            details: [
              {
                title: "",
                infoFields: [
                  {
                    subject: "",
                    text: "",
                    type: "text",
                    url: "",
                  },
                ],
              },
            ],
          });
          addHTMLFileNumber();
        }}
      >
        Add HTML file
      </button>

      <div
        className={overlayActive ? "overlay-visible" : "overlay"}
        onClick={resetOverlay}
      ></div>
    </div>
  );
};

export default AdPositionListItem2;
